// ponytail: deep imports skip @upfrontjs/framework's barrel, which drags its model layer (qs, lodash.*, ~110KB)
// into the entry chunk for five helpers. Same code, just not the index. Typed from the package's own types.
import type * as Upfront from '@upfrontjs/framework';
// @ts-expect-error -- untyped deep path, typed below
import isObjectLiteralFn from '#upfront/function/isObjectLiteral.js';
// @ts-expect-error -- untyped deep path, typed below
import transformKeysFn from '#upfront/function/transformKeys.js';
// @ts-expect-error -- untyped deep path, typed below
import snakeFn from '#upfront/string/snake.js';
// @ts-expect-error -- untyped deep path, typed below
import wordsFn from '#upfront/string/words.js';
// @ts-expect-error -- untyped deep path, typed below
import pluralFn from '#upfront/string/plural.js';

export const isObjectLiteral = isObjectLiteralFn as typeof Upfront.isObjectLiteral;
export const transformKeys = transformKeysFn as typeof Upfront.transformKeys;
export const snake = snakeFn as typeof Upfront.snake;
export const words = wordsFn as typeof Upfront.words;
export const plural = pluralFn as typeof Upfront.plural;
